import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import CryptoJS from 'crypto-js'
import Swal from 'sweetalert2';
import { CircularProgress } from '@mui/material';
import CategoryHeader from '../../../Components/Headers/CategoryHeader';
import axios from 'axios';
import axiosInstance from '../../../Utilities/djangoAxiosInstance';


const EKYC_ReturnUrl = () => {

    const [ekycStatus, setEkycStatus] = useState('PENDING')
    const [next, setNext] = useState(true)
    const [quickQuoteDetails, setQuickQuoteDetails] = useState();
    const [requestID, setRequestID] = useState()
    const [pageReady, setPageReady] = useState(false)




    let navigate = useNavigate();
    let location = useLocation();
    const { productId } = useParams();

    const productIdArray = productId.split('*')
    const productRef = productIdArray[0]
    const responseId = productIdArray[1]


    let productRef_Hexa = CryptoJS.enc.Hex.parse(productRef);
    let bytesProdRef = productRef_Hexa.toString(CryptoJS.enc.Base64);
    let decryptProduct_Ref = CryptoJS.AES.decrypt(bytesProdRef, 'secret key @123');
    let plainProductRef = decryptProduct_Ref.toString(CryptoJS.enc.Utf8);
    let originalProductRef = plainProductRef.replace(/["]/g, '');

    let responseId_Hexa = CryptoJS.enc.Hex.parse(responseId);
    let bytesResponseId = responseId_Hexa.toString(CryptoJS.enc.Base64);
    let decryptResponseId = CryptoJS.AES.decrypt(bytesResponseId, 'secret key @124');
    let plainResponseId = decryptResponseId.toString(CryptoJS.enc.Utf8);
    let originalResponseId = plainResponseId.replace(/["]/g, '');
    console.log('hh', productIdArray, plainProductRef, typeof (plainResponseId), originalResponseId)
    //const Acuvisor_product_id = productIdArray[2]  

    //const productRefURI = decodeURIComponent(productRef).toString()
    //const responseIdURI = decodeURIComponent(responseId).toString()
    //const Acuvisor_product_idURI = decodeURIComponent(Acuvisor_product_id).toString() 


    // const bytesProductRefURI = CryptoJS.AES.decrypt(productRefURI, 'secret key @123');
    //const bytesResponseIdURI = CryptoJS.AES.decrypt(responseIdURI, 'secret key @124');
    // const bytesAcuvisor_product_idURI = CryptoJS.AES.decrypt(Acuvisor_product_idURI, 'secret key @124');

    //console.log(productIdArray,productRefURI)
    //const decryptedProductRef = JSON.parse(bytesProductRefURI.toString(CryptoJS.enc.Utf8));
    //const decryptedResponseId = JSON.parse(bytesResponseIdURI.toString(CryptoJS.enc.Utf8));
    //   const decryptedAcuvisor_product_id = JSON.parse(bytesAcuvisor_product_idURI.toString(CryptoJS.enc.Utf8)); 

console.log('ll',pageReady)
    useEffect(() => {

        //console.log('sss', location.search.split('&'))
        let reqID = ''
        if (location.search !== "") {
            let splitAnd = location.search.split('&')
            let splitReqID = splitAnd[0].split('=')
            let splitStatus = splitAnd[1].split('=')
            reqID = splitReqID[1]
            //setRequestID(splitReqID[1])
            console.log('SPL', splitReqID, splitStatus)
            if (splitStatus[1] === 'failure') {
                console.log('fail')
               setPageReady(true)
                setEkycStatus('FAILURE')
            } else if (splitStatus[1] === 'success') {

                setEkycStatus('SUCCESS')
            }
        }

        let domain = ''


        if (window.location.hostname === 'localhost') {
            domain = process.env.REACT_APP_LOCAL_DJANGO
        } else if (window.location.hostname.trim() === 'it.acuvisor.com') {
            domain = process.env.REACT_APP_PRODUCTION_DJANGO
        } else {
            domain = process.env.REACT_APP_UAT_DJANGO
        }

        axiosInstance.get(`api/health/transfer-data/${String(originalResponseId)}/`).then((response) => {
            if (response.status === 200) {
                console.log('response from djamgoo ', response)
                let reqBodyEadhar = {
                    "eadharDetailsIO": {
                        "task": "getEadhaar",
                        "essentials": {
                            "requestId": reqID
                        }
                    }
                }
        
                axiosInstance.post(`/api/health-insurance/care/ekyc/aadhar-details/${String(originalResponseId)}/${response.data.A_id}/`, JSON.stringify(reqBodyEadhar))
                    .then(res => {
                        //setNext(false)
                        console.log('getEadhr', res)
                        setPageReady(true)
                    })
                setQuickQuoteDetails(response.data);

            }

        })


        


    }, [])


    const nextHandler = () => {

        let path = ''
        let encryptedProduct_ref = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(originalProductRef), 'secret key @123').toString());
        let encryptedDataId = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(originalResponseId), 'secret key @124').toString());

        path = `/health-insurance/product/${encryptedProduct_ref}*${encryptedDataId}`;
        navigate(path)
    }

    const goBack = () => {
        navigate(-1);
    }

    const failureEkycStatus = () => {
        Swal.fire({
            icon: 'error',
            title: 'EKYC Status Failed',
            text: 'Please click on NEXT button to proceed next',
            position: 'center',
        })/* .then(result => {
            //setNext(false)
        }) */
    }

    const successEkycStatus = () => {
        Swal.fire({
            icon: 'success',
            title: 'EKYC Status Success',
            text: 'Please click on NEXT button to proceed next',
            position: 'center',
        })/* .then(result => {
            console.log('swl', result)

            let domain = ''
           
            console.log('req', reqBodyEadhar)
            if (window.location.hostname === 'localhost') {
                domain = process.env.REACT_APP_LOCAL_DJANGO
            } else if (window.location.hostname.trim() === 'it.acuvisor.com') {
                domain = process.env.REACT_APP_PRODUCTION_DJANGO
            } else {
                domain = process.env.REACT_APP_UAT_DJANGO
            }

           

        }) */
    }

    const renderBasedStatus = (ekycStatus) => {
        switch (ekycStatus) {
            case 'PENDING':
                return <div className='d-flex justify-content-center'>
                    <CircularProgress
                        size={48}
                        sx={{
                            color: 'red',

                        }} />
                </div>
                break;
            case 'FAILURE':
                //setPageReady(true)
                failureEkycStatus()
                break

            case 'SUCCESS':
                successEkycStatus()
                break

        }
    }

    return (
        <div>
            <div className=" ">
                <CategoryHeader title="Health Insurance" />
            </div>
            {
                pageReady ?
                    <div>
                        <div>
                            {
                                renderBasedStatus(ekycStatus)
                            }
                            <h3>EKYC Status {ekycStatus}</h3>
                        </div>


                        <div className=" btn-sec  position-fixed bottom-0 ">
                            <button className="reset-btn text-capitalize"

                                onClick={goBack}
                            >
                                Go Back
                            </button>
                            <button className="submitBtn text-capitalize "
                                //disabled={next}
                                onClick={nextHandler}
                            //disabled={next}

                            >
                                Next
                            </button>
                        </div>
                    </div>
                    :
                    <div className='d-flex justify-content-center'>
                        <CircularProgress />
                    </div>
            }

        </div>
    )
}

export default EKYC_ReturnUrl